module.exports = __webpack_public_path__ + "static/img/map.4fe6d79.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/map.png
// module id = jm99
// module chunks = 1